import { render } from "./ArchiveView.vue?vue&type=template&id=7f31f924&scoped=true"
import script from "./ArchiveView.vue?vue&type=script&lang=js"
export * from "./ArchiveView.vue?vue&type=script&lang=js"

import "./ArchiveView.vue?vue&type=style&index=0&id=7f31f924&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f31f924"]])

export default __exports__